export const availableLinesConfig = {
    hash: 'linhas-disponiveis',
    color: 'info',
    variant: 'outlined',
    icon: 'FormatAlignLeft',
    width: 300,
    elemment: 'LineCard',
    scheduleType: 'calendar'
};

export const notEscaletedLinesNextConfig = {
    hash: 'linhas-nao-escaladas-amanha',
    color: 'warning',
    variant: 'outlined',
    icon: 'Warning',
    width: 300,
    elemment: 'LineCard',
    scheduleType: 'single',
    offset: 1
};

export const notEscaletedLinesTodayConfig = {
    hash: 'linhas-nao-escaladas-hoje',
    color: 'error',
    variant: 'outlined',
    icon: 'PlaylistRemove',
    width: 300,
    elemment: 'LineCard',
    scheduleType: 'single',
    offset: 0
};

export const escaletedLinesTodayConfig = {
    hash: 'viagens-do-dia',
    color: 'success',
    variant: 'outlined',
    icon: 'TaskAlt',
    width: 300,
    elemment: 'TripCard',
    scheduleType: 'single',
    offset: 0
};

export const n1AlertConfig = {
    hash: 'n1-horapegada',
    title: 'N1 (HORA PEGADA)',
    color: 'dark',
    variant: 'contained',
    icon: 'VpnKey',
    width: 250,
    elemment: 'TripCard'
};

export const n2AlertConfig = {
    hash: 'n2-ponto-inicial',
    title: 'N2 (PRIMEIRO PONTO)',
    color: 'dark',
    variant: 'contained',
    icon: 'VpnKey',
    width: 250,
    elemment: 'TripCard'
};

export const n3AlertConfig = {
    hash: 'n3-tres-primeiros',
    color: 'dark',
    title: 'N3 (3 PRIMEIROS PONTOS)',
    variant: 'contained',
    icon: 'VpnKey',
    width: 250,
    elemment: 'TripCard'
};

export const HASH_CONFIGS = [
    availableLinesConfig,
    notEscaletedLinesNextConfig,
    notEscaletedLinesTodayConfig,
    escaletedLinesTodayConfig,
    n1AlertConfig,
    n2AlertConfig,
    n3AlertConfig
];

export const HASH_CONFIG_MAP = new Map(
    HASH_CONFIGS.map(c => [c.hash, c])
);